/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Timeline_TitleInputs */

const id_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const ms_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const da_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const de_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const en_us2_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const es_es2_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de compilaciones observadas`)
};

const es_mx2_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de compilaciones observadas`)
};

const fil_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const fr_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const it_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const hu_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const nl_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const no_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const pl_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const pt_br2_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const pt_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const ro_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const fi_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const sv_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const vi_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const tr_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const cs_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const bg_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const ru_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наблюдаемая история сборок`)
};

const uk_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const ar_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const hi_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`देखे गए बिल्ड का इतिहास`)
};

const th_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประวัติบิลด์ที่พบ`)
};

const ja_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const zh_cn2_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

const zh_hant1_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`觀察到的組建歷史`)
};

const ko_builds_timeline_title = /** @type {(inputs: Builds_Timeline_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observed build history`)
};

/**
* | output |
* | --- |
* | "Observed build history" |
*
* @param {Builds_Timeline_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_timeline_title = /** @type {((inputs?: Builds_Timeline_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Timeline_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_timeline_title(inputs)
	if (locale === "ms") return ms_builds_timeline_title(inputs)
	if (locale === "da") return da_builds_timeline_title(inputs)
	if (locale === "de") return de_builds_timeline_title(inputs)
	if (locale === "en-US") return en_us2_builds_timeline_title(inputs)
	if (locale === "es-ES") return es_es2_builds_timeline_title(inputs)
	if (locale === "es-MX") return es_mx2_builds_timeline_title(inputs)
	if (locale === "fil") return fil_builds_timeline_title(inputs)
	if (locale === "fr") return fr_builds_timeline_title(inputs)
	if (locale === "it") return it_builds_timeline_title(inputs)
	if (locale === "hu") return hu_builds_timeline_title(inputs)
	if (locale === "nl") return nl_builds_timeline_title(inputs)
	if (locale === "no") return no_builds_timeline_title(inputs)
	if (locale === "pl") return pl_builds_timeline_title(inputs)
	if (locale === "pt-BR") return pt_br2_builds_timeline_title(inputs)
	if (locale === "pt") return pt_builds_timeline_title(inputs)
	if (locale === "ro") return ro_builds_timeline_title(inputs)
	if (locale === "fi") return fi_builds_timeline_title(inputs)
	if (locale === "sv") return sv_builds_timeline_title(inputs)
	if (locale === "vi") return vi_builds_timeline_title(inputs)
	if (locale === "tr") return tr_builds_timeline_title(inputs)
	if (locale === "cs") return cs_builds_timeline_title(inputs)
	if (locale === "bg") return bg_builds_timeline_title(inputs)
	if (locale === "ru") return ru_builds_timeline_title(inputs)
	if (locale === "uk") return uk_builds_timeline_title(inputs)
	if (locale === "ar") return ar_builds_timeline_title(inputs)
	if (locale === "hi") return hi_builds_timeline_title(inputs)
	if (locale === "th") return th_builds_timeline_title(inputs)
	if (locale === "ja") return ja_builds_timeline_title(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_timeline_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_timeline_title(inputs)
	return ko_builds_timeline_title(inputs)
});
export { builds_timeline_title as "builds.timeline.title" }